import Vue from "vue";
import axios from "axios";
import VueAxios from 'vue-axios';

import TokenService from '../common/tokenService';
import router from '../router'
class ApiServiceProvider {
  constructor() {
    this.init();
  }
  init() {
    // setting up default service provider
    Vue.use(VueAxios, axios);
    // setting up base URL
    Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
    // Add a request interceptor
    axios.interceptors.request.use(
      config => {
        const token = TokenService.getToken();
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
      },
      error => {
        Promise.reject(error)
      });
    // Add a request interceptor
    axios.interceptors.response.use(response => {
      // Intercept response
      return response;
    }, error => {
      // intercept Error
      // If error contains 401 response code means -user is unauthenticated - redirect to login/home view.
      if (error.response.status === 401) {
        TokenService.removeToken();
        router.push('/');
      }
      throw error;
    });

    console.log("Initialized API Service with baseURL= " + Vue.axios.defaults.baseURL);
  }
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${TokenService.getToken()}`;
  }
  getInstance() {
    return Vue.axios;
  }
}

const ApiService = (new ApiServiceProvider()).getInstance();
export default ApiService;
